import { HomePage } from "./Component/HomePage";

function App() {
  return (
    <div className="App">
      <h1><HomePage/></h1>
    </div>
  );
}

export default App;
